<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm_title">Acknowledgements</h2>
<p class="noindent">Robert ‘Lee’ Leffert, Warren Fuller and Connor Dotson provided details for several of the stories included within this ‘TINS’ collection. Richard ‘Tricky’ Cross, First Cav Loach Driver and recipient of the Silver Medal, provided careful proofreading. Robert McNaughton and Warren Fuller provided proofreading services and wordsmithing.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Ackn.vue?150e64fe